import { GlobalTranslationsList } from '../../../compositions/global-translations/list/global-translation-list';
import { useGlobalTranslationItems } from '../../../data/data/translations/use-global-translations-items';
import { Content } from '../../../elements/content/content';

export function AdminGlobalTranslationsPage() {
  const {
    data: globalTranslationItemsData,
    loading: globalTranslationItemsLoading,
  } = useGlobalTranslationItems({
    onlyDefault: false,
  });

  return (
    <Content>
      <GlobalTranslationsList
        loading={globalTranslationItemsLoading}
        items={globalTranslationItemsData}
        onClick={() => {}}
      />
    </Content>
  );
}
